const dispatch_rule = {
  label: '分配规则',
  type: 'radio-group',
  isButton: true,
  labelTips: '全局分配：图片/视频素材、标题配置在所有账户内循环分配，在新账户内将从上一个账户最后一项配置接续循环</br>按账户分配：图片/视频素材、标题配置在单账户内循环分配，在新账户内将从第一项配置重新开始循环</br>注：广告定向、落地页配置默认均为按账户分配',
  options: [
    { label: '全局分配', value: 1 },
    { label: '按账户分配', value: 2 },
  ],
  value: 1,
};

export {
  dispatch_rule, // 分配规则
};
